import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// `perms`: UX-only gate for EMPLOYEE (any-of). OWNER always passes. Backend remains authoritative.
export default function ProtectedRoute({ children, roles, perms }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-center text-gray-500">جاري التحميل…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (perms && user.role === "EMPLOYEE" && !perms.some((p) => user.permissions?.[p])) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
